import { createUseStyles } from 'react-jss';

export const asTabsLgSelectedStyles = {
  color: 'var(--primary-main)',
  backgroundColor: 'var(--background-default)',
  border: `1px solid var(--primary-main)`,
};

const useStyles = createUseStyles(() => ({
  viboMenu: {
    padding: '0',
    margin: '0',
    boxShadow: 'none',
    border: 'none',
    fontFamily: 'Roboto, sans-serif',
    // color: 'var(--text-primary)',

    '&[class*="rc-menu"]': {
      padding: '0',
      margin: '0',
      boxShadow: 'none',
      border: 'none',
    },

    '&.rc-menu-horizontal': {
      backgroundColor: 'transparent',
    },

    '&.asTabs, &.asTabsLg': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '12px',

      '& .menuItem': {
        color: 'var(--text-hint)',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '19.5px',
        padding: '4px 13px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid var(--text-hint)`,
        paddingTop: 0,
        paddingBottom: 0,
        borderRadius: '4px',

        '&.rc-menu-item-selected': {
          ...asTabsLgSelectedStyles,
        },

        '&:hover': {
          '&:not(.rc-menu-item-disabled)': {
            borderColor: 'var(--button-active)',
            backgroundColor: 'var(--primary-lighty)',
            color: 'var(--button-active)',

            '&:not(.rc-menu-item-selected)': {
              color: 'var(--text-secondary)',
              backgroundColor: 'transparent',
              borderColor: 'var(--text-secondary)',
            },
          },
        },

        '& .suffix': {
          textTransform: 'lowercase',
          marginLeft: '4px',
        },

        '@media screen and (min-width: 1441px)': {
          fontSize: '16px',
          lineHeight: '24px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        gap: '16px',
      },
    },

    '&.asTabsLg': {
      height: '30px',

      '& .menuItem': {
        height: '100%',
      },

      '@media screen and (min-width: 1441px)': {
        height: '36px',
      },
    },

    '&.asTabsIos': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'var(--primary-lighty)',
      borderRadius: '4px',
      boxShadow: 'var(--shadows-9)',
      padding: '2px',

      '& .menuItem': {
        borderRadius: '4px',
        color: 'var(--text-hint)',
        fontWeight: 500,
        fontSize: '15px',
        lineHeight: '19.5px',
        padding: '6px 14px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',

        '&.rc-menu-item-selected, &.rc-menu-item-active': {
          backgroundColor: 'var(--background-paper)!important',
          color: 'var(--text-primary)',
          boxShadow: 'var(--shadows-10)',
        },

        '@media screen and (min-width: 1441px)': {
          fontSize: '18px',
          lineHeight: '24px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        gap: '16px',
      },
    },

    '&.asBadgesLg': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',

      '& .menuItem': {
        color: 'var(--text-hint)',
        borderRadius: '34px',
        gap: '6px',
        fontSize: '13px',
        lineHeight: '17px',
        padding: '6px 12px',

        '&:not(.rc-menu-item-selected):not(.rc-menu-item-active)': {
          backgroundColor: 'var(--text-light)!important',
        },

        '&:not(.rc-menu-item-selected)': {
          '&.rc-menu-item-active': {
            color: 'var(--text-primary)',
            backgroundColor: 'var(--background-dropDown)!important',
          },
        },

        '&.rc-menu-item-selected': {
          color: 'var(--whiteToShipGray)',
          backgroundColor: 'var(--text-secondary)!important',

          '&.rc-menu-item-active': {
            color: 'var(--whiteToBlack)',
            backgroundColor: 'var(--text-primary)!important',
          },
        },

        '@media screen and (min-width: 1441px)': {
          fontSize: '16px',
          lineHeight: '21px',
          padding: '8px 16px',
        },
      },
    },

    '&.siderTop': {
      height: '100%',
      borderRadius: 0,

      '& .menuItem': {
        fontSize: '15px',
        height: '100%',
        color: 'var(--text-primary)',
        padding: 0,
        border: 'none',

        '&.rc-menu-item-selected': {
          color: 'var(--primary-main)',
          backgroundColor: 'transparent',

          '&:after': {
            content: '""',
            width: '100%',
            height: '2px',
            backgroundColor: 'var(--primary-main)',
            position: 'absolute',
            left: 0,
            bottom: 0,
          },
        },

        '& .menuItemContent': {
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        },

        '&:not(:last-child)': {
          margin: '0 36px 0 0',
        },

        '&:hover': {
          backgroundColor: 'transparent',
        },

        '@media screen and (min-width: 1441px)': {
          fontSize: '18px',
        },
      },
    },

    '&.siderLeft': {
      borderRadius: 0,

      '& .menuItem': {
        fontSize: '13px',
        color: 'var(--text-secondary)',
        padding: '12px',
        width: '100%',

        '&.rc-menu-item-active': {
          backgroundColor: 'transparent',
        },

        '&.rc-menu-item-selected': {
          borderRight: `2px solid var(--primary-main)`,
          color: 'var(--primary-main)',
          backgroundColor: 'transparent',
        },

        '& .menuItemContent > .viboIcon': {
          marginRight: '8px',

          '@media screen and (min-width: 1441px)': {
            marginRight: '12px',
          },
        },

        '&, &:last-of-type': {
          borderBottom: `1px solid var(--background-default)`,
        },

        '&:hover': {
          '&:not(.rc-menu-item-selected)': {
            background: 'var(--background-default)',
          },
        },

        '@media screen and (min-width: 1441px)': {
          fontSize: '16px',
          padding: '12px 16px',
        },
      },
    },
  },

  menuItem: {
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background-color .2s',

    '&.danger:not(:hover)': {
      '& > *': {
        color: 'var(--error-main)',
      },
    },

    '&.rc-menu-item-disabled': {
      cursor: 'not-allowed',
      // color: 'var(--text-hint)!important',
    },

    '&.rc-menu-item': {
      padding: '8px 12px',
    },

    '& a': {
      display: 'block',
      width: '100%',
      height: '100%',
      padding: '12px 8px 12px 12px',
      textDecoration: 'none',

      '&:active': {
        color: 'var(--text-secondary)',
      },
    },
  },

  menuItemContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export default useStyles;
